import { createSelector } from "reselect";

import reducerRegistry from "../../util/reducerRegistry";
import {
  REDUCER_NAME,
  RESET_PLAYERSTATISTICS,
  SET_ERROR,
  SET_PLAYERSTATISTICS,
} from "./constants";

const initialState = {
  isReady: false,
  isError: false,
  competitions: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PLAYERSTATISTICS:
      return {
        ...state,
        isReady: true,
        isError: false,
        competitions: action.data,
      };
    case RESET_PLAYERSTATISTICS:
      return initialState;
    case SET_ERROR:
      return {
        ...state,
        isReady: false,
        isError: true,
      };
    default:
      return state;
  }
};

const getState = (state) => {
  if (state[REDUCER_NAME]) {
    return state[REDUCER_NAME];
  }
  return initialState;
};

export const selectIsReady = createSelector(getState, (n) => n.isReady);

export const selectIsError = createSelector(getState, (n) => n.isError);

export const selectPlayerStatistics = createSelector(
  getState,
  (n) => n.competitions
);

export const selectPlayerStatisticsKeys = createSelector(getState, (n) =>
  n.competitions.reduce(
    (acc, m) => [...new Set([...acc, ...Object.keys(m.statistics)])],
    []
  )
);

reducerRegistry.register(REDUCER_NAME, reducer);
